tinymce.PluginManager.add('axupimgs', function (editor, url) {
	var pluginName = '多图片上传';
	window.axupimgs = {}; //扔外部公共变量，也可以扔一个自定义的位置

	var iframe1 = window.location.host.indexOf("localhost") >= 0 ? '/tinymce/upfiles.html' : 'https://' + window.location.host + '/tinymce/upfiles.html';
	axupimgs.images_upload_handler = editor.getParam('images_upload_handler', undefined, 'function');
	axupimgs.images_upload_base_path = editor.getParam('images_upload_base_path', '', 'string');
	axupimgs.axupimgs_filetype = editor.getParam('axupimgs_filetype', '.png,.gif,.jpg,.jpeg', 'string');
	axupimgs.res = [];
	var openDialog = function () {
		return editor.windowManager.openUrl({
			title: pluginName,
			size: 'large',
			url: iframe1,
			buttons: [
				{
					type: 'cancel',
					text: 'Close'
				},
				{
					type: 'custom',
					text: 'Save',
					name: 'save',
					primary: true
				},
			],
			onAction: function (api, details) {
				switch (details.name) {
					case 'save':
						var html = '';
						var imgs = axupimgs.res;
						var len = imgs.length;
						for (let i = 0; i < len; i++) {
							if (imgs[i].url) {
								html += '<p><img src="' + imgs[i].url + '" width="100%" height="auto" /></p>';
							}
						}
						editor.insertContent(html);
						axupimgs.res = [];
						api.close();
						break;
					default:
						break;
				}

			}
		});
	};

	editor.ui.registry.getAll().icons.axupimgs || editor.ui.registry.addIcon('axupimgs', '<svg width="24" height="24" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><style type="text/css">.st0{clip-path:url(#SVGID_2_);fill:none;stroke:#333333;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:2;}.st1{clip-path:url(#SVGID_2_);fill:none;stroke:#333333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2;}</style><g><defs><rect id="SVGID_1_" x="0" width="24" height="24"/></defs><clipPath id="SVGID_2_"><use xlink:href="#SVGID_1_"  style="overflow:visible;"/></clipPath><path class="st0" d="M5,3.5h14.3c0.4,0,0.6,0,0.7,0.1c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.3,0.1,0.8v13.3"/><path class="st1" d="M2.5,6.7h14.7v13.8H2.5V6.7z"/><path class="st2" d="M7.8,12.3c0.8,0,1.5-0.7,1.5-1.5S8.7,9.3,7.8,9.3S6.3,10,6.3,10.8S7,12.3,7.8,12.3z"/><path class="st0" d="M2.8,20.2L6.4,15l1.9,2l3.9-3.5l4.6,6.7"/></g></svg>');

	editor.ui.registry.addButton('axupimgs', {
		icon: 'axupimgs',
		tooltip: pluginName,
		onAction: function () {
			openDialog();
		}
	});
	editor.ui.registry.addMenuItem('axupimgs', {
		icon: 'axupimgs',
		text: '图片批量上传...',
		onAction: function () {
			openDialog();
		}
	});
	return {
		getMetadata: function () {
			return {
				name: pluginName,
				url: "http://tinymce.ax-z.cn/more-plugins/axupimgs.php",
			};
		}
	};
});
